import { QueryClient } from '@tanstack/react-query';
import { sellerKeys } from './queryKeys';

const silentInvalidate = (queryClient: QueryClient, queryKey: readonly unknown[]) =>
  queryClient.invalidateQueries({
    queryKey,
    refetchType: 'active',
  });

/** After mutations or notifications — refresh related seller data without clearing the UI. */
export function invalidateSellerLiveData(
  queryClient: QueryClient,
  scope?: 'message' | 'offer' | 'order' | 'payment' | 'all'
) {
  const tasks: Promise<void>[] = [];

  const invalidate = (queryKey: readonly unknown[]) => {
    tasks.push(silentInvalidate(queryClient, queryKey));
  };

  if (!scope || scope === 'all') {
    invalidate(sellerKeys.all);
    return Promise.all(tasks).then(() => undefined);
  }

  if (scope === 'message') {
    invalidate(sellerKeys.conversations());
  }

  if (scope === 'offer') {
    invalidate(sellerKeys.offersPrefix());
    invalidate(sellerKeys.pendingOfferCount());
    invalidate(sellerKeys.conversations());
  }

  if (scope === 'order') {
    invalidate(sellerKeys.ordersPrefix());
    invalidate(sellerKeys.paymentsPrefix());
    invalidate(sellerKeys.stats());
  }

  if (scope === 'payment') {
    invalidate(sellerKeys.paymentsPrefix());
    invalidate(sellerKeys.stats());
  }

  return Promise.all(tasks).then(() => undefined);
}

export function notificationTypeToInvalidateScope(
  type?: string
): 'message' | 'offer' | 'order' | 'payment' | undefined {
  if (!type) return undefined;
  if (type === 'message') return 'message';
  if (type === 'offer' || type === 'bid') return 'offer';
  if (type === 'order') return 'order';
  if (type === 'payment') return 'payment';
  return undefined;
}
